const ContactMixin = {
  methods: {
    createContact(contact) {
      const url = route("public.api.contacts.store");

      return axios.post(url, contact);
    },
  },
};

export default ContactMixin;
